export const serviceCategoriesTranslations = {
    services_categories: {
        comprehensiveTesting: {
            id: "comprehensive-testing",
            title: "Comprehensive testing services",
            subtitle: "Your software deserves perfection, let us ensure it! ✅",
            description: "Our Comprehensive Testing Services deliver flawless functionality, superior performance, and exceptional user experiences. With cutting-edge tools, AI-driven methodologies, and a team of seasoned QA professionals, we provide testing solutions that ensure your software meets the highest standards in every release.",
        },
        coachingServices: {
            id: "mentoring-coaching",
            title: "Mentoring and coaching",
            subtitle: "Empowering your team with expert guidance and knowledge transfer 🎓",
            description: "Our mentoring and coaching services help build internal QA capabilities within your organization. We provide personalized guidance, best practices implementation, and strategic consulting to elevate your team's testing expertise.",
        },
        crowdTesting: {
            id: "crowd-testing",
            title: "Crowd testing services",
            subtitle: "Leverage the power of global testing community 🌍",
            description: "Our crowd testing services harness the collective expertise of a global testing community to provide diverse perspectives, real-world testing scenarios, and comprehensive coverage across different devices, platforms, and user behaviors.",
        }
    }
}